define( function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/css/var/cssExpand.js
// module id = 9DDo
// module chunks = 0 1